import React, {useEffect, useRef, useState} from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material';

import { withStyles } from "@mui/styles";
import {API_ROOT} from "../../../baseUrls";
import ContentArea from "../../organisms/content-area/ContentArea";
import {TermsOfService} from "./TermsOfService";
import DesigneesForm from "./DesigneesForm";
import {ENABLE_CAPTCHA} from "../../../config";
import ReCAPTCHA from "react-google-recaptcha";
import {CheckCircleOutline, ErrorOutline, RadioButtonUnchecked} from "@mui/icons-material";
import InfoText from "../../util/common/InfoText";

const styles = {
  root:{
    maxWidth: 720,
    margin: "16px auto 64px",
    borderTop: '1px solid rgba(0,0,0,0.12)'
  },
  title:{
    marginTop: 0,
    // textAlign: 'center',
    fontWeight: '400',
    wordBreak:'break-word',
    // margin: '0 auto 1.5rem'
  },
  terms:{
    width: "100%",
    marginTop: '0.5rem',
    border: "1px solid rgba(0,0,0,0.23)",
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  termsScroll:{
    height: "16em",
    maxHeight: "16em",
    width: "100%",
    overflowY: "scroll",
    whiteSpace: 'pre-wrap',
    padding: '0.5rem',
    fontSize: '0.85rem',
    fontWeight: '300',
    boxSizing: 'border-box',
  },
  errors:{
    backgroundColor: '#ffbdbd',
    padding: '4px 8px',
    borderRadius: '4px'
  },
  error:{
  },
  column:{
    display:"flex",
    flexDirection: "column",
    flexWrap: "wrap",
    gap: '1em'
  },
  inputColumn:{
    display:"flex",
    flexDirection: "column",
    flexWrap: "wrap",
    // gap: '1em'
  },
  inputRow:{
    display:"flex",
    flexWrap:"wrap",
    alignItems: 'center',
    gap: '1em',
    width: '100%'
  },
  inputSingle:{
    width: '100%'
  },
  input:{
    width: '100%',
    maxWidth: '20em',
    minWidth: '10em'
  },
  available:{ color: "#2e7d32" },
  unavailable:{ color: "#f44336" },
  unknown:{ color: "rgba(0,0,0,0.52)" },
  info:{
    alignItems: 'center',
    display: 'flex',
    gap: '0.5rem',
    height: '24px',
    minHeight: '24px',
    width: '185px',
    minWidth: '185px',
  },
  infoLoader:{
    display: 'inline-flex',
    height: '24px',
    minHeight: '24px',
    width:'26px',
    minWidth:'26px'
  }
};

const validationMessages = {
  username: "* Username is required.",
  unavailable: "Username is unavailable.",
  email: "* Email is required.",
  emailConfirm: "Email confirmation does not match.",
  password: "* Password is required.",
  passwordConfirm: "Password confirmation does not match.",
  terms: "Terms of Service not accepted.",
  captcha: "Captcha is required.",
};

function SignupForm(props) {
  const { classes } = props;
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [designee1, setDesignee1] = useState("");
  const [relationship1, setRelationship1] = useState("");
  const [designee2, setDesignee2] = useState("");
  const [relationship2, setRelationship2] = useState("");
  const [designee3, setDesignee3] = useState("");
  const [relationship3, setRelationship3] = useState("");

  const [doNotDisclose, setDoNotDisclose] = useState(true);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [validations, setValidations] = useState({
    username: false,
    unavailable: false,
    email: false,
    emailConfirm: false,
    password: false,
    passwordConfirm: false,
    terms: false,
    captcha: false
  });
  const [registrationComplete, setRegistrationComplete] = useState(false);
  const [registrationInProgress, setRegistrationInProgress] = useState(false);
  const [usernameAvailable, setUsernameAvailable] = useState(4);
  const [recaptchaResponse, setRecaptchaResponse] = useState('');
  const recaptchaRef = useRef(null);
  const captchaEnabled = typeof(ENABLE_CAPTCHA) !== 'undefined' && ENABLE_CAPTCHA;


  const validateFields = {
    username: () => !username,
    unavailable: () => usernameAvailable === 0,
    email: () => !email,
    emailConfirm: () => email !== emailConfirm,
    password: () => !password,
    passwordConfirm: () => password !== passwordConfirm,
    terms: () => !termsAccepted,
    captcha: () => captchaEnabled && !recaptchaResponse
  };
  const isValid =  !validations.username && !validations.unavailable && !validations.email && !validations.emailConfirm && !validations.password && !validations.passwordConfirm && !validations.terms && !validations.captcha;
  const curValid = !validateFields.username() && !validateFields.unavailable() && !validateFields.email() && !validateFields.emailConfirm() && !validateFields.password() && !validateFields.passwordConfirm() && !validateFields.terms() && !validateFields.captcha();

  const validate = () => {
    const v = {
      username: !username,
      unavailable: usernameAvailable === 0,
      email: !email,
      emailConfirm: email !== emailConfirm,
      password: !password,
      passwordConfirm: password !== passwordConfirm,
      terms: !termsAccepted,
      captcha: captchaEnabled && !recaptchaResponse,
    };
    setValidations(v);
    return !v.username && !v.unavailable && !v.email && !v.emailConfirm && !v.password && !v.passwordConfirm && !v.terms && !v.captcha;
  };

  const registerUser = () => {
    if(registrationInProgress){
      return;
    }
    setRegistrationInProgress(true);
    if(!validate()){
      setRegistrationInProgress(false);
      return;
    }
    fetch(
      `${API_ROOT}/register_user`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          user: {
            username:username,
            email:email,
            email_confirmation:emailConfirm,
            password:password,
            password_confirmation:passwordConfirm,
            // designees:designees,
            do_not_disclose:doNotDisclose,
            terms_of_service: termsAccepted,
            designee1:designee1,
            relationship1:relationship1,
            designee2:designee2,
            relationship2:relationship2,
            designee3:designee3,
            relationship3:relationship3
          },
          "g-recaptcha-response": recaptchaResponse,
        }),
        headers: {
          // 'X-CSRF-Token': authToken,
          "Content-Type": "application/json"
        },
      }
    )
    .then((resp) => resp.json())
    .then((data) => {
      if(data.status && data.status === "ok"){
        setRegistrationComplete(true);
      }else if(data.status === "error"){
        setErrorMessages(data.messages);
        recaptchaRef.current && recaptchaRef.current.reset();
      }
    })
    .catch(error => {
      console.error(error);
      setErrorMessages(["There was an error with your registration.  Please try again later."]);
      recaptchaRef.current && recaptchaRef.current.reset();
    })
    .finally(() => setRegistrationInProgress(false));
  }

  const check_username = () => {
    if(!username){
      setUsernameAvailable(4);
      return;
    }
    setUsernameAvailable(2);
    fetch(
      `${API_ROOT}/check_username`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({username:username}),
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if(data.status && data.status === "ok"){
          setUsernameAvailable(data.available ? 1 : 0);
        }else if(data.status === "error"){
          setUsernameAvailable(3);
        }
      })
      .catch(error => {
        console.error(error);
        setUsernameAvailable(3);
      })
  };

  useEffect(check_username, [username]);

  return (
    <Card className={classes.root}>
      { !registrationComplete ?
        <form autoComplete="off">
          <CardContent>
            <h2 className={classes.title}>LifeNaut Sign Up</h2>
            <div className={classes.column}>
              {errorMessages.length === 0 && (isValid || curValid) ? null :
                <Typography id="errorMessages" component="div" color="textSecondary" gutterBottom className={classes.errors}>
                  { errorMessages.map(error =>
                    <div key={error} className={classes.error}>{error}</div>
                  )}
                  {Object.keys(validations).filter(key => validateFields[key]()).map(key =>
                    <div key={key} className={classes.error}>{validationMessages[key]}</div>
                  )}
                </Typography>
              }
              <div className={classes.inputRow}>
                <TextField id='username' label='Username'
                  margin='none' size='small' variant='outlined' className={classes.input}
                  value={username}
                  onChange={event => {setUsername(event.target.value)}}
                  error={(validations.username || validations.unavailable) && (!username || usernameAvailable === 0)}
                  disabled={registrationInProgress}
                  required
                />
                {usernameAvailable === 0 ?
                    <InfoText id="available" className={`${classes.info} ${classes.unavailable}`}><ErrorOutline /> Username is unavailable</InfoText>
                  : usernameAvailable === 1 ?
                    <InfoText id="available" className={`${classes.info} ${classes.available}`}><CheckCircleOutline /> Username is available</InfoText>
                  : usernameAvailable === 2 ?
                    // <InfoText className={`${classes.info} ${classes.unknown}`}><div className={classes.infoLoader}><LoadingCircle size="xs" color="inherit" /></div> Checking username...</InfoText>
                    <InfoText id="available" className={`${classes.info} ${classes.unknown}`}><RadioButtonUnchecked /> Username is </InfoText>
                  : usernameAvailable === 3 ?
                    <InfoText id="available" className={`${classes.info} ${classes.unknown}`}>&nbsp;</InfoText>
                  :
                    <InfoText id="available" className={`${classes.info} ${classes.unknown}`}></InfoText>
                }
              </div>
              <div className={classes.inputSingle}>
                <TextField id='email' label='Email'
                  margin='none' size='small' variant='outlined' className={classes.input}
                  value={email}
                  onChange={event => {setEmail(event.target.value)}}
                  error={validations.email && !email}
                  disabled={registrationInProgress}
                  required
                />
              </div>
              <div className={classes.inputSingle}>
                <TextField id='emailConfirm' label='Confirm Email'
                  margin='none' size='small' variant='outlined' className={classes.input}
                  value={emailConfirm}
                  onChange={event => {setEmailConfirm(event.target.value)}}
                  error={validations.emailConfirm && email !== emailConfirm}
                  disabled={registrationInProgress}
                  required
                />
              </div>
              <div className={classes.inputSingle}>
                <TextField id='password' label='Password'
                  margin='none' size='small' variant='outlined' className={classes.input} type='password'
                  value={password}
                  onChange={event => {setPassword(event.target.value)}}
                  error={validations.password && !password}
                  disabled={registrationInProgress}
                  required
                />
              </div>
              <div className={classes.inputSingle}>
                <TextField id='passwordConfirm' label='Confirm Password'
                  margin='none' size='small' variant='outlined' className={classes.input} type='password'
                  value={passwordConfirm}
                  onChange={event => {setPasswordConfirm(event.target.value)}}
                  error={validations.passwordConfirm && password !== passwordConfirm}
                  disabled={registrationInProgress}
                  required
                />
              </div>
              <div className={classes.inputSingle}>
                <DesigneesForm
                  registrationInProgress={registrationInProgress}
                  {...{
                    designee1: designee1,
                    setDesignee1: setDesignee1,
                    relationship1: relationship1,
                    setRelationship1: setRelationship1,
                    designee2: designee2,
                    setDesignee2: setDesignee2,
                    relationship2: relationship2,
                    setRelationship2: setRelationship2,
                    designee3: designee3,
                    setDesignee3: setDesignee3,
                    relationship3: relationship3,
                    setRelationship3: setRelationship3,
                    doNotDisclose: doNotDisclose,
                    setDoNotDisclose: setDoNotDisclose
                  }}
                />
              </div>
              <div className={classes.inputColumn}>
                <div className={classes.inputSingle}>
                  Terms of Service:
                </div>
                <div className={classes.terms}>
                  <div id="tos" className={classes.termsScroll}>
                    {TermsOfService}
                  </div>
                </div>
                <div className={classes.inputSingle}>
                  <FormControl
                    required
                    error={validations.terms && !termsAccepted}
                    component="fieldset"
                  >
                    <FormControlLabel
                      id="acceptTerms"
                      required
                      control={
                        <Checkbox
                          id="acceptTermsCB"
                          checked={termsAccepted}
                          onClick={() => setTermsAccepted(!termsAccepted)}
                          disabled={registrationInProgress}
                          style={validations.terms && !termsAccepted ? {color: '#f44336'} : {}}
                        />}
                      label={<FormHelperText variant="standard">Accept Terms of Service</FormHelperText>}
                    />
                  </FormControl>
                </div>
              </div>
              { captchaEnabled &&
                <div className={classes.inputSingle}>
                  <FormControl
                    required
                    error={validations.captcha && (captchaEnabled && !recaptchaResponse)}
                    component="fieldset"
                  >
                    <ReCAPTCHA
                      sitekey='6LfaYIUeAAAAAILmLoRvqHd-8-7rGt0V7QwHZOkf'
                      onChange={response => setRecaptchaResponse(response)}
                      ref={recaptchaRef}
                    />
                    {validations.captcha && (captchaEnabled && !recaptchaResponse) ?
                      <FormHelperText variant="standard">Complete the captcha</FormHelperText>
                      : null
                    }
                  </FormControl>
                </div>
              }
            </div>
          </CardContent>
          <CardActions>
            <div style={{padding: 8, position: 'relative'}}>
              <Button
                id="commit"
                variant='contained'
                color='primary'
                disabled={registrationInProgress} //|| (captchaEnabled && !recaptchaResponse)}
                onClick={registerUser}
              >
                Signup
              </Button>
              { registrationInProgress ?
                <CircularProgress size={24} style={{position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12}}/>
                : null
              }
            </div>
          </CardActions>
        </form>
        :
        <CardContent>
          <h3 id="signupSuccess">Signup Complete</h3>
          <ContentArea>
            Please check your email for a link to activate your account.
          </ContentArea>
        </CardContent>
      }
    </Card>
  )
}
export default withStyles(styles)(SignupForm);